<template>
  <v-app>
    <div style="width: 100%; zoom: 0.90; margin: 0 auto; padding: 15px; text-align: left; font-family: 'Times New Roman', Times, serif;">
      <table style="width: 100%;">
        <tr>
          <td v-if="logo!=null" style="width: fit-content; vertical-align: top;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
          <td style="width:40%; padding-left: 15px;">
            <p style="margin-top: 0;margin-bottom: 0; text-align: left; line-height: 1;"><span style="white-space: pre; font-size: 10pt;">{{ getCompanySetting('CompanySettings', 'CompanyAddress')}}</span></p>
          </td>
          <td>&nbsp;</td>
          <td style="width: 35%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Statement Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ new Date(initvalue.statement_date).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 10px; padding-bottom: 10px;"></div>
      <table style="width: 100%">
        <tr>
          <td><div style="text-align: center;"><h4 class="ma-0"><b>{{ initvalue.statement_title }}</b></h4></div></td>
        </tr>
        <tr>
          <td><div style="text-align: center; font-size: medium;"><b>{{ initvalue.statement_subtitle }}</b></div></td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%;">
        <tr>
          <td style="width:45%; padding-left: 15px;">
            <div style=" text-align: start; margin: 0;">
              <span style="font-size: 11pt; font-weight: bold; text-align: start;">Customer</span>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.customername }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.customeraddress }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.customerphone }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.customermobile }}</p>
            </div>          
          </td>
          <td>&nbsp;</td>
          <td style="width: 45%; vertical-align: text-top; align-items: end;">
            &nbsp;
          </td>
        </tr>
      </table>
      <div style="padding-top: 7px; padding-bottom: 7px;"></div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="15%">Num</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="15%">Inv Date</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="15%">Due Date</th>
            <th style="text-align: right; border-bottom: 1px; border-bottom-style: solid" width="15%">Inv Amount</th>
            <th colspan="2" style="text-align: center; border-bottom: 1px; border-bottom-style: solid">Outstanding Balance</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(invoice) in initvalue.invoices"  v-bind:key="invoice._id">
            <td style="vertical-align: top; padding-bottom: 5px;"><b>Invoice {{ invoice.invoicenum }}</b></td>
            <td style="vertical-align: top; padding-bottom: 5px;">{{ new Date(invoice.invoicedate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
            <td style="vertical-align: top; padding-bottom: 5px;">{{ invoice.invoiceduedate!=null ? new Date(invoice.invoiceduedate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}</td>
            <td style="vertical-align: top; padding-bottom: 5px; text-align: right; padding-right: 10px;">{{ invoice.invoicetotal.toFixed(2) }} <span style="font-size: 8pt;">{{ invoice.primaryCurrency }}</span></td>
            <td style="vertical-align: top; padding-bottom: 5px; text-align: right;">{{ data_balance_2(invoice) }} <span style="font-size: 8pt;">{{ invoice.secondaryCurrency }}</span></td>
            <td style="vertical-align: top; padding-bottom: 5px; text-align: right"><b>{{ invoice.balance.toFixed(2) }} <span style="font-size: 8pt;">{{ invoice.primaryCurrency }}</span></b></td>
          </tr>
          <tr><td colspan="6" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
          <tr v-if="initvalue.invoices!=null">
            <td colspan="4" style="vertical-align: top; padding-bottom: 5px;">&nbsp;</td>
            <td style="vertical-align: top; padding-bottom: 5px; text-align: right">{{ sum_total_2 }} <span style="font-size: 8pt;">{{ initvalue.invoices.length>0 ? initvalue.invoices[0].secondaryCurrency : '' }}</span></td>
            <td style="vertical-align: top; padding-bottom: 5px; text-align: right"><b>{{ sum_total }} <span style="font-size: 8pt;">{{ initvalue.invoices.length>0 ? initvalue.invoices[0].primaryCurrency : '' }}</span></b></td>
          </tr>
          <tr><td colspan="6">&nbsp;</td></tr>
        </tbody>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
    </div>
  </v-app>
</template>
<script>
import {mapActions} from "vuex";
import { getLogo } from '../../util/tools';

export default {
  name: 'PrintInvoice',
  props: {
    id: String
  },
  data() {
    return {
      logo: null,
      initvalue: {},
      data_company: {},
    }
  },
  methods: {
    ...mapActions('PrintApi', ['getCustomerOpenInvoiceRequest', 'getCompanyDataRequest']),
    getCompanySetting(code, name){
      if(this.data_company.settings==null || this.data_company.settings.length==0) return '';
      let results = this.data_company.settings.find(setting=>setting.settingcode==code);
      let result = results.settinglists.find(result=>result.settingname==name);
      let value = result!=null ? result.settingvalue : '';
      if(value.trim()=='true') value=true;
      else if(value.trim()=='false') value=false;
      return value;
    },
    data_account(id){
      if(this.data_company.accounts==null || this.data_company.accounts.length==0) return null;
      let account = this.data_company.accounts.find(i=>i._id == id);
      if(account!=null) return account['accountcode'];
      return '';
    },
    convertCurrency(amount){
      let rate = parseFloat(this.initvalue.currencyRate);
      if(rate==null) rate = 0;
      return amount * rate;
    },
    data_balance_2(invoice){
      let rate = parseFloat(invoice.currencyRate);
      if(rate==null) rate = 1;
      let result = invoice.balance * rate;
      return result.toFixed(2)
    },

  },
  computed: {
    data_location(){
      if(this.data_company.locations==null || this.data_company.locations.length==0) return null;
      let location = this.data_company.locations.find(i=>i._id == this.initvalue.locationid);
      if(location!=null) return location['locationcode'];
      return '';
    },
    data_region(){
      if(this.data_company.regions==null || this.data_company.regions.length==0) return null;
      let region = this.data_company.regions.find(i=>i._id == this.initvalue.regionid);
      if(region!=null) return region['regionname'];
      return '';
    },
    data_paymethod(){
      if(this.data_company.paymethods==null || this.data_company.paymethods.length==0) return null;
      let paymethod = this.data_company.paymethods.find(i=>i._id == this.initvalue.paymethodid);
      if(paymethod!=null) return paymethod;
      return null;
    },
    sum_total(){
      if(this.initvalue==null || this.initvalue.invoices==null) return 0;
      let result = this.initvalue.invoices;
      result = result.reduce((a, b) => a + (b.balance), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return result;
    },
    sum_total_2(){
      if(this.initvalue==null || this.initvalue.invoices==null) return 0;
      let result = this.initvalue.invoices;
      result = result.reduce((a, b) => a + (b.balance * b.currencyRate), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return result;
    },
  },
  async created() {
    if(this.id){
      this.initvalue = await this.getCustomerOpenInvoiceRequest(this.id);
      console.log(this.initvalue)
      //if(this.initvalue==null) this.$router.push({ path: '/error' });
      this.logo = getLogo(this.initvalue.companyid);
      this.data_company = await this.getCompanyDataRequest(this.initvalue.companyid);
    }
  },
}

</script>

<style src="./Print.scss" lang="scss"/>
